export const DUTCHIE_TERMS_URL = 'https://dutchie.com/terms';
export const DUTCHIE_PRIVACY_URL = 'https://dutchie.com/privacy';
